<template>
    <div class="container heading">
        <div class="row">
            <div class="heading-header">
                <button type="button" class="btn btn-primary" id="EQDefinitionbtn" style="align-content:end" @click="generateEQDefinition">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 11.8a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8 10.293V1.5a.5.5 0 0 0-1 0v8.793L4.354 8.093a.5.5 0 1 0-.708.708l3 3z" />
                    </svg> 2023 Questionnaire Definitions
                </button>
                <h2>EMPLOYMENT SUMMARY REPORT</h2>
                <h6>SECTION OF LEGAL EDUCATION</h6>
            </div>
            <div class="singlesection">
                <h4>INDIVIDUAL SCHOOL SUMMARY REPORTS</h4>
            </div>
            <div class="singleyearinput">
                <span>Select the Year: </span>
                <select v-model="selectedYearSingle" class="form-select" aria-label="year select">
                    <option value="">Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
            </div>
            <div class="singleschoolinput">
                <span>Select the School: </span>

                <select v-if="selectedYearSingle" v-model="selectedSchoolSingle" class="form-select" aria-label="school select">
                    <option value="">Select School</option>
                    <option v-for="school in schools" :key="school" :value="school">{{ school }}</option>

                </select>
                <select v-else-if="!selectedYearSingle" v-model="selectedSchoolSingle" class="form-select" aria-label="school select">
                    <option value="">Select School</option>
                </select>
            </div>
            <div class="singlegeneratebtn">
                <button type="button" class="btn" @click="generateSingleReport">Generate Report</button>
            </div>
            <hr style="border: 1px solid black; margin-top: 1.5vw; margin-bottom:-1vw;">

            <div class="compsection">
                <h4>COMPILATION - ALL SCHOOLS DATA</h4>
            </div>
            <div class="compyearinput">
                <span>Select the Year: </span>
                <select v-model="selectedYearComp" class="form-select" aria-label="year select">
                    <option value="">Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
            </div>
            <div class="compbtn">
                <button type="button" class="btn" @click="generateCompReport">Generate Report</button>
            </div>
            <div class="note">
                <div class="icon" id="noteicon">
                    <img src="../assets/note.png" alt="Notification Icon" style="width:20px; height:20px" />
                </div>
                <h2>Notification</h2>
                <p>The data reported here are submitted by law schools to the ABA. The ABA assumes no responsibility for inaccuracies or for changes in such information that may occur after publication.</p>

            </div>
            <div v-if="loading" class="loading-overlay">
                <div class="spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'EmploymentOutcomes',
        data() {
            return {
                selectedYearSingle: '',
                selectedSchoolSingle: '',
                selectedYearComp: '',
                years: [2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010],
                schools: [],
                schoolCodes: {},
                loading: false,
                API_URL: process.env.VUE_APP_ROOT_API,
                EQProtocol: process.env.VUE_APP_EQProtocol,

            };
        },
        watch: {
            async selectedYearSingle(newYear) {
                if (newYear) {
                    await this.fetchSchools();
                }
                this.selectedSchoolSingle='';
            },
        },
        methods: {
            async fetchSchools() {

                try {
                    const res = await axios.get(`${this.API_URL}Master/GetEQUniversityListByYear`, {
                        params: {
                            schoolYear: this.selectedYearSingle,
                        },
                    });
                    const universityList = res.data.universityListEntities;
                    this.schools = universityList.map(university => university.schoolName);
                    this.schoolCodes = universityList.reduce((acc, university) => {
                        acc[university.schoolName] = university.schoolCode;
                        return acc;
                    }, {});
                }
                catch (error) {
                    console.error('Error fetching data:', error);
                }
            },
            async generateSingleReport() {
                if (this.selectedYearSingle && this.selectedSchoolSingle) {
                    try {
                        this.loading = true;
                        const schoolCode = this.schoolCodes[this.selectedSchoolSingle];
                        const response = await axios.get(`${this.API_URL}EmploymentOutcomes/GenerateIndividualEQSummaryReport`, {
                            params: {
                                schoolId: schoolCode,
                                year: this.selectedYearSingle,
                            },
                            responseType: 'blob',
                        });
                        const blob = new Blob([response.data], {
                            type: response.headers['content-type'],
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        const file_Name = `EmploymentSummary_${this.selectedYearSingle}.pdf`;
                        link.download = file_Name;
                        link.click();
                        link.remove();
                    }
                    catch (error) {
                        console.error('Error generating single report:', error);
                        alert('An error occurred while generating the report. Please try again later.');
                    }
                    finally {
                        this.loading = false; // Stop loading
                    }
                }
                else {
                    alert('Please select both year and school.');
                }
            },
            async generateCompReport() {
                if (this.selectedYearComp) {
                    try {
                        this.loading = true;
                        const response = await axios.get(`${this.API_URL}EmploymentOutcomes/GenerateEQCompilationReport`, {
                            params: {
                                year: this.selectedYearComp,
                            },
                            responseType: 'blob',
                        });
                        const blob = new Blob([response.data], {
                            type: response.headers['content-type'],
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        const file_name = `Employment_Summary_${this.selectedYearComp}.xlsx`;
                        link.download = file_name;
                        link.click();
                        link.remove();
                    }
                    catch (error) {
                        console.error('Error generating compilation report:', error);
                        alert('An error occurred while generating the report. Please try again later.');
                    }
                    finally {
                        this.loading = false; // Stop loading
                    }
                }
                else {
                    alert('Please select year.');
                }
            },
            async generateEQDefinition() {
                try {
                    this.loading = true;
                    const response = await axios.get(`${this.API_URL}EmploymentOutcomes/DownloadEQInstructions`, {
                        responseType: 'blob',
                    });
                    const blob = new Blob([response.data], {
                        type: response.headers['content-type'],
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.EQProtocol;
                    link.click();
                    link.remove();
                }
                catch (error) {
                    console.error('Error Downloading report:', error);
                    alert('An error occurred while downloading. Please try again later.');
                }
                finally {
                    this.loading = false; // Stop loading
                }
            },


        }
    }
</script>

<style scoped>
    .container {
        position: relative;
        color: black;
        height: 100%;
        padding-top: 1vw;
        padding-left: 2vw;
        font-family: Helvetica;
        font-weight: 700;
    }
</style>
